import React, { useState } from 'react';
import { Image as ImageIcon, Upload as UploadIcon, Trash2, ListFilter } from 'lucide-react';
import ImageUploadTab from './ImageUploadTab';
import ImageRemoveTab from './ImageRemoveTab';
import ImageMappingsTab from './ImageMappingsTab';

export default function ImageManagerPage() {
  const [tab, setTab] = useState('upload');

  return (
    <div className="page-scroll" data-testid="image-manager-page">
      <div className="page-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <ImageIcon size={22} style={{ color: 'var(--accent)' }} />
          <h1 className="page-title" style={{ margin: 0 }}>Bildhanterare</h1>
        </div>
        <p className="page-subtitle">
          Massuppladdning och borttagning av produktbilder direkt mot Norce.
        </p>
      </div>

      <div className="tab-switcher" style={{ marginBottom: 24 }}>
        <button
          data-testid="img-tab-upload"
          className={`tab-btn${tab === 'upload' ? ' tab-btn--active' : ''}`}
          onClick={() => setTab('upload')}
        >
          <UploadIcon size={14} style={{ marginRight: 6, verticalAlign: '-2px' }} />
          Ladda upp
        </button>
        <button
          data-testid="img-tab-remove"
          className={`tab-btn${tab === 'remove' ? ' tab-btn--active' : ''}`}
          onClick={() => setTab('remove')}
        >
          <Trash2 size={14} style={{ marginRight: 6, verticalAlign: '-2px' }} />
          Ta bort bilder
        </button>
        <button
          data-testid="img-tab-mappings"
          className={`tab-btn${tab === 'mappings' ? ' tab-btn--active' : ''}`}
          onClick={() => setTab('mappings')}
        >
          <ListFilter size={14} style={{ marginRight: 6, verticalAlign: '-2px' }} />
          Mappningar
        </button>
      </div>

      {tab === 'upload'   && <ImageUploadTab />}
      {tab === 'remove'   && <ImageRemoveTab />}
      {tab === 'mappings' && <ImageMappingsTab />}
    </div>
  );
}
